import { ApolloCache, Reference, StoreObject } from "@apollo/client"

export function evictSurveyFromCache(cache: ApolloCache<unknown>, surveyId: number): boolean {
  const surveyIdentifier: StoreObject = {
    __typename: "Survey",
    id: surveyId,
  }

  return cache.evict({ id: cache.identify(surveyIdentifier) })
}

export function evictThemesWithCustomQuestionsQueryFromCache(cache: ApolloCache<unknown>): boolean {
  return cache.evict({
    args: {
      limit: 0,
      withCustomQuestionsOnly: true,
    },
    fieldName: "themes",
    id: "ROOT_QUERY",
  })
}

export function evictSurveysWithQuestionFromCache(cache: ApolloCache<unknown>, questionId: number): boolean {
  // Remove the cache of getQuestions used in custom surveys page to display choices for selected questions
  cache.evict({
    args: {
      id: questionId,
    },
    fieldName: "getQuestion",
    id: "ROOT_QUERY",
  })

  // Remove the cache of surveys that contains the edited question in the custom surveys page
  return cache.modify({
    fields: {
      survey: (surveyRef: Reference, { DELETE, readField }) => {
        const questions = readField<readonly Reference[]>("questions", surveyRef) ?? []
        const isEditedQuestionInSurvey = questions.some(questionRef => readField("id", questionRef) === questionId)

        return isEditedQuestionInSurvey ? DELETE : surveyRef
      },
    },
    id: "ROOT_QUERY",
  })
}
